import React, { Component } from "react";
import {
  Button,
  Segment,
  Header,
  Icon,
  Form,
  Grid,
  Image,
  Message
} from "semantic-ui-react";

const style = {
  NextButton: {
    textAlign: "right"
  },
  pictureHead: {
    textAlign: "center"
  },
  removeButton: {
    textAlign: "right"
  }
};

export default class BookUploadPic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formError: []
    };

    this.clearError = this.clearError.bind(this);
    this.checkForm = this.checkForm.bind(this);

    this.handlePrev = this.handlePrev.bind(this);
    this.handleNextPic = this.handleNextPic.bind(this);
    this.handleFinish = this.handleFinish.bind(this);
    this.handlePeopleChange = this.handlePeopleChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleUploadPicture = this.handleUploadPicture.bind(this);
  }

  clearError(){
    this.setState({ formError : [] });
  }

  checkForm() {
    var errorList = [];
    if(!this.props.formValue.picture){
      errorList.push("Please upload a picture");
    }else if(!this.props.formValue.isValidPicture()){
      errorList.push("Invalid picture");
    }

    this.setState({ formError : errorList });

    return errorList.length === 0;
  }

  handlePrev() {
    if(this.checkForm()){
      this.props.onPrev();
    }
  }

  handleNextPic() {
    if(this.checkForm()){
      this.props.onNext();
    }
  }

  handleFinish() {
    if(this.checkForm()){
      this.props.onFinish();
    }
  }

  handlePeopleChange(e) {
    var newValue = this.props.formValue;
    newValue.people = e.target.value;
    this.props.onFormValueChange(newValue);
  }

  handleDescriptionChange(e) {
    var newValue = this.props.formValue;
    newValue.description = e.target.value;
    this.props.onFormValueChange(newValue);
  }

  handleUploadPicture(e){
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      var newValue = this.props.formValue;
      newValue.picture = reader.result;
      this.props.onFormValueChange(newValue);
    }

    reader.readAsDataURL(file)
  }

  render() {
    var errorMassage = null;
    if(this.state.formError.length !== 0){
      errorMassage = (
        <Message
          error
          header='Error'
          list={this.state.formError}
        />
      );
    }

    return (
      <Grid centered>
        <Grid.Row centered>
          <Grid.Column width={14} style={style.pictureHead}>
            <Header as="h1" content={"Picture " + this.props.picnum} />
          </Grid.Column>
          <Grid.Column width={2} floated='right' style={style.removeButton}>
            <Button icon onClick={this.props.onRemove}>
              <Icon name='remove' />
            </Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            { this.props.formValue.picture ?
              (<Image src={this.props.formValue.picture} />) :
              (<Segment placeholder>
                <Header icon>
                  <Icon name="picture" color="grey" />
                  Upload Your Picture Here
                </Header>
                <Button as="label" className="imageUpload" primary>
                  <input type='file'
                    accept="image/*"
                    onChange={this.handleUploadPicture} />
                  Add Picture
                </Button>
              </Segment>)
            }
          </Grid.Column>
          <Grid.Column>
            <Form error={this.state.formError.length !== 0} >
              <Form.Input
                label="People"
                placeholder="People in the picture (Left to Right)"
                value={this.props.formValue.people}
                onChange={this.handlePeopleChange}
              />
              <Form.TextArea
                label="Description"
                placeholder="Descriptions, Location, Any Specifics about \
                the photo that you would like to \
                included"
                rows={5}
                value={this.props.formValue.description}
                onChange={this.handleDescriptionChange}
              />
              {errorMassage}
            </Form>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Button onClick={this.handlePrev}>Back</Button>
          </Grid.Column>
          <Grid.Column style={style.NextButton}>
            <Button.Group>
              <Button primary onClick={this.handleNextPic}>{this.props.isLast ? "Add More Pictures" : "Next"}</Button>
              <Button.Or />
              <Button positive onClick={this.handleFinish}>Finish</Button>
            </Button.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
